export const TIME_MARKER_DRAG_ITEM = 'dragg-item';
export const TIME_TABLE_ACTIVITY_CLASSNAME = 'time-table-activity';
export const TIME_TABLE_ROW = 'time-table-row';
export const UNSELECTABLE_CLASSNAME = 'g-unselectable';

export const DEFAULT_ACTIVITY_CLASSNAME = `${TIME_TABLE_ACTIVITY_CLASSNAME} ${UNSELECTABLE_CLASSNAME}`;
export const MILESTONE_CLASSNAME = `${DEFAULT_ACTIVITY_CLASSNAME} milestone`;
export const PARENT_ACTIVITY_CLASSNAME = `${DEFAULT_ACTIVITY_CLASSNAME} parent-activity`;
export const HIGHLIGHT_CLASS = 'highlight';
export const SELECTION_CLASS = 'selected';
export const SELECT_CONTENT_CLASSNAME = 'select-content';

export const DECORATION_INVALID_TYPE = 'invalid';
export const DECORATION_INVALID_CLASS = 'time-table-invalid';
export const DECORATION_BREAK_TYPE = 'break';
export const DECORATION_BREAK_CLASS = 'time-table-break';
